import * as React from "react";
import * as ReactDOM from "react-dom";
import classNames from "classnames";
import { ProxyBaseClass } from "@bizform/core/dist/js/bizflow/core.min";

type Props = {
    appendTo?: HTMLElement;
    menuStyle?: object;
    menuClassName?: string;
};

type State = {
};

@ProxyBaseClass("low", "componentWillUnmount")
export class HiddenButtonPanel extends React.Component<Props, State> {

    private _element: HTMLElement;

    constructor(props: Props) {
        super(props);
    }

    componentWillUnmount(): void {
    }

    getElement(): HTMLElement {
        return this._element;
    }

    private _renderElement(): React.ReactNode {
        const className = classNames("p-menu p-menu-dynamic p-menu-overlay p-component", this.props.menuClassName);

        return (
            <div className={className} style={this.props.menuStyle} ref={(el) => { this._element = el; }}>
                <ul className="p-menu-list p-reset">
                    {this.props.children}
                </ul>
            </div>
        );
    }

    render(): React.ReactNode {
        const element = this._renderElement();

        if (this.props.appendTo) {
            return ReactDOM.createPortal(element, this.props.appendTo);
        } else {
            return this._element;
        }
    }
}